export interface IKetQuaKey {
    area: string;
    loaicuoc: string;
    socuoc: string;
    ngay: string;
    sonhay: number;
}
export interface KetQuaStruct {
    area: string;
    ngay: string;
    tengiai: string;
    sodaydu: string;
}
export class KetQuaKey implements KetQuaKey {
    area: string = "";
    loaicuoc: string = "";
    socuoc: string = "";
    ngay: string = "";
    sonhay: number = 0;
    constructor(

    ) {

    }
}
export interface SoCuocKey {
    Area1: string;
    Area2: string;
    LoaiCuoc: string;
    SoCuoc: string;
    MN_TinhThuongDaXien_05: number; // thưởng 0,5 ki
    MN_TinhThuongDaXien_05_NhieuLan: number; // thưởng 0,5 ki
    MN_TinhThuongDaXien_2: number; // thưởng nhiều ki
    MN_TinhThuongDaThang_05: number; // thưởng 0,5 ki
    MN_TinhThuongDaThang_05_NhieuLan: number; // thưởng 0,5 ki
    MN_TinhThuongDaThang_2: number; // thưởng nhiều ki
    MB_TinhThuongDaThang_05: number; // thưởng 0,5 ki
    MB_TinhThuongDaThang_05_NhieuLan: number; // thưởng 0,5 ki
    MB_TinhThuongDaThang_2: number; // thưởng nhiều ki
}
export function SoCuocKeyDefault(): SoCuocKey {
    return {
        Area1: "",
        Area2: "",
        LoaiCuoc: "",
        SoCuoc: "",
        MN_TinhThuongDaXien_05: 0,
        MN_TinhThuongDaXien_05_NhieuLan: 0,
        MN_TinhThuongDaXien_2: 0,
        MN_TinhThuongDaThang_05: 0,
        MN_TinhThuongDaThang_05_NhieuLan: 0,
        MN_TinhThuongDaThang_2: 0,
        MB_TinhThuongDaThang_05: 0,
        MB_TinhThuongDaThang_05_NhieuLan: 0,
        MB_TinhThuongDaThang_2: 0,
    }
}